import { render, staticRenderFns } from "./CampaignDetailHeader.vue?vue&type=template&id=5bc94305&scoped=true"
import script from "./CampaignDetailHeader.vue?vue&type=script&lang=js"
export * from "./CampaignDetailHeader.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetailHeader.vue?vue&type=style&index=0&id=5bc94305&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc94305",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
